import styled from 'styled-components'
import { ToolButton } from '../buttons'
import { PauseIcon, PlayIcon, SoundOffIcon, SoundOnIcon } from '../icons'

const Button = styled(ToolButton)`
    align-items: center;
    bottom: 10px;
    display: flex;
    height: 30px;
    justify-content: center;
    position: absolute;
    width: 30px;
`

const VolumeButton = styled(Button)`
    right: 10px;
`

const PauseButton = styled(Button)`
    left: 10px;
`

type Props = {
    isPlaying: boolean
    isMuted?: boolean
    onMuteToggle?: (isMuted: boolean) => void
    onPlayToggle: (isPlaying: boolean) => void
}

const CreationSourcePlayerControls = ({ isPlaying, isMuted, onMuteToggle, onPlayToggle }: Props) => (
    <>
        {onMuteToggle && (
            <VolumeButton onClick={() => onMuteToggle(!isMuted)}>
                {isMuted ? <SoundOffIcon /> : <SoundOnIcon />}
            </VolumeButton>
        )}
        <PauseButton onClick={() => onPlayToggle(!isPlaying)}>{isPlaying ? <PauseIcon /> : <PlayIcon />}</PauseButton>
    </>
)

export default CreationSourcePlayerControls
